import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import Breadcrumb from "../components/Reusable/Breadcrumb";
import InfoBox from "../components/Reusable/InfoBox";
import { fetchCatalogLevelList } from "../actions/level";
import { fetchRewardListAll } from "../actions/reward";
import { useTranslation } from "react-i18next";

const RewardPage = () => {
  const dispatch = useDispatch();
  const { rewardUserListAll } = useSelector((state) => state.rewardReducer);
  const { levelCatalogList } = useSelector((state) => state.levelReducer);
  const { t } = useTranslation();

  useEffect(() => {
    dispatch(fetchCatalogLevelList());
  }, [dispatch]);

  // Kada su levele dostupni, povuci rewarde
  useEffect(() => {
    if (levelCatalogList && levelCatalogList.length > 0) {
      dispatch(fetchRewardListAll());
    }
  }, [levelCatalogList, dispatch]);

  // Pripremi podatke za prikaz
  const levelsWithRewards = levelCatalogList?.map((level) => {
    const levelId = level.levelId;
    const rewardsForLevel = rewardUserListAll?.filter(
      (reward) => reward.levelId === levelId
    );
    return {
      ...level,
      rewards: rewardsForLevel || [],
    };
  });

  return (
    <div className="order-main-container">
      <Breadcrumb title={t("header.benefits")} returnPage="/" />

      <h5
        className="reward-list-all-title"
        dangerouslySetInnerHTML={{ __html: t("benefit_title") }}
      ></h5>

      <div className="container-holder-main-reward-list-all">
        {levelsWithRewards?.slice(1).map((level) => (
          <div key={level.id} className="mb-4">
            <div className="reward-list-holder-title-image">
              <img src={level?.badge} className="img-fluid" />
              <h2 className="text-xl font-bold mb-2">
                {t(`level.${level.name}`)}
              </h2>
            </div>

            {level.rewards.length > 0 ? (
              <div className="reward-list-items-list">
                {level.rewards.map((reward) => (
                  <div className="reward-list-item" key={reward.id}>
                    <img
                      src={reward.image}
                      className="img-fluid"
                      alt={reward.name}
                    />
                    <div className="reward-list-item-name">{reward.name}</div>
                    {/* <div className="reward-list-item-points">
                      {reward.points} bodova
                    </div> */}
                  </div>
                ))}
              </div>
            ) : (
              <div className="text-gray-500">
                <InfoBox text={"Nema dostupnih benefita."} />
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default RewardPage;
